import { Action } from 'redux';
import { ClientReport } from 'model/ClientAndPetsReport';

//Action Types
export const CLIENT_REPORT_GET_START = 'CLIENT_REPORT_GET_START';
export const CLIENT_REPORT_GET_SUCCESS = 'CLIENT_REPORT_GET_SUCCESS';
export const CLIENT_REPORT_GET_ERROR = 'CLIENT_REPORT_GET_ERROR';

//Actions

type ClientReportGetStartAction = Action<typeof CLIENT_REPORT_GET_START>;

interface ClientReportGetSuccessAction extends Action<typeof CLIENT_REPORT_GET_SUCCESS> {
    payload: {
        pets: Array<ClientReport>;
        page?: number | string;
        size?: number | string;
        totalPages?: number | string;
        totalRecords?: number | string;
    };
}

type ClientReportErrorAction = Action<typeof CLIENT_REPORT_GET_ERROR>;

export type ClientReportAction = ClientReportGetStartAction | ClientReportGetSuccessAction | ClientReportErrorAction;
